import { useCallback } from 'react'
import logger from 'logger'
import { useApolloClient } from 'apollo-client'
import { ServerError, UserError } from 'helpers'

import addressValidateQuery from './graph/addressValidateOld.graphql'


const useShippingAddressValidateOld = () => {
  const apolloClient = useApolloClient()

  return useCallback(async (enteredValues: UserModule.ShippingFormFields) => {
    const { data } = await apolloClient.mutate({
      mutation: addressValidateQuery,
      variables: {
        input: {
          firstName: enteredValues.firstName,
          lastName: enteredValues.lastName,
          country: enteredValues.country,
          city: enteredValues.city,
          region: enteredValues.region,
          postalCode: enteredValues.postalCode,
          street1: enteredValues.street1,
          street2: enteredValues.street2,
          phone: enteredValues.phone,
        },
      },
      fetchPolicy: 'no-cache',
    })

    const { error } = data.addressValidate

    logger.info(`[Address validation] address is ${!error ? 'valid' : 'invalid'}`, {
      extra: {
        response: data.addressValidate,
      },
    })

    // address is ok, but validation is required
    if (error?.__typename === 'AmbiguousAddressError') {
      const suggestion = error.suggestions[0]

      return {
        isValid: false,
        recommendedValues: {
          firstName: suggestion.firstName,
          lastName: suggestion.lastName,
          country: suggestion.country,
          city: suggestion.city,
          region: suggestion.region,
          postalCode: suggestion.postalCode,
          street1: suggestion.street1,
          street2: suggestion.street2,
          phone: suggestion.phone,
        },
      }
    }

    // address error (not found)
    if (error?.__typename === 'AddressValidationError') {
      throw new UserError(error, error.message)
    }

    // server error
    if (error) {
      throw new ServerError(error, 'Address validation error')
    }

    // address is correct and validated
    const { data: { address, isPrimaryAddress } } = data.addressValidate

    return {
      isPrimaryAddress,
      isValid: true,
      // we do this to remove all extra attributes from the response too
      recommendedValues: {
        firstName: address.firstName,
        lastName: address.lastName,
        country: address.country,
        city: address.city,
        region: address.region,
        postalCode: address.postalCode,
        street1: address.street1,
        street2: address.street2,
        phone: address.phone,
      },
    }
  }, [ apolloClient ])
}


export default useShippingAddressValidateOld
